var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modalback",on:{"click":_vm.closeAction}},[_c('div',{staticClass:"modalcontent container"},[_c('div',{staticClass:"row justify-content-center align-items-center h-100"},[_c('div',{staticClass:"col h-100"},[_c('img',{staticClass:"img-fluid h-100",attrs:{"src":this.$store.state.imagePopupImage}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }